import { ICreateWireDisbursementProps } from 'API/order/escrow/WireDisbursementAPI';
import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';
import {
  convertWireDisbursementFormDataToUpdateRequest,
  convertWireDisbursementFormDataToWireDisbursementRequest,
} from 'types/order/escrow/request/IWireDisbursementRequest';

export const convertWireDisbursementDataToCreateWireDisbursement = (
  wire: IWireDisbursementFormData,
  escrowFileId: string,
  orderId: string
): ICreateWireDisbursementProps => {
  return {
    orderId,
    escrowFileId,
    newWireData: {
      ...convertWireDisbursementFormDataToWireDisbursementRequest(wire, 'v2'),
    },
  };
};

export const convertWireDisbursementFormDataToUpdateWireDisbursement = (
  wire: IWireDisbursementFormData,
  orderId: string
) => ({
  orderId,
  updateWireData: convertWireDisbursementFormDataToUpdateRequest(wire, 'v2'),
});
